import { animate, motion, useMotionValue, useTransform } from "framer-motion";
import { useEffect } from "react";

export default function NumberTicker({
  startValue = 0,
  endValue,
  duration = 1000,
  delay = 0,
}: {
  startValue?: number;
  endValue: number;
  duration?: number;
  delay?: number;
}) {
  const formatNumber = (num: number) => {
    return Intl.NumberFormat().format(num);
  };

  const count = useMotionValue(startValue);
  const rounded = useTransform(count, (latest) =>
    formatNumber(Math.round(latest)),
  );

  useEffect(() => {
    const controls = animate(count, endValue, {
      duration,
      delay,
    });

    return () => controls.stop();
  }, [count, delay, duration, endValue]);

  return <motion.span>{rounded}</motion.span>;
}
